export default {
  READY: 1,
  OPEN: 2,
  DOWNLOADED: 6,
  LOADING: 7,
  DEPARTED: 9,
  OFFLINE: 11,
  IN_BUILD: 13,
  VOID: 14,
};
